module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='  <div class="navlogo display-none">\n    <a href="#dashboard" style="padding-left: 15px;">\n      <img class="svg stat_cpu"\n        src="img/cpu.svg"\n      />\n      <img class="svg stat_ram"\n        src="img/ram.svg"\n        style="background-color: #FAFF92; margin-top: 9px; margin-left: 4px; margin-right: 2px;"\n      />\n      <img class="svg stat_req"\n        src="img/requests.svg"\n        style="background-color: #8aa051; margin-top: 9px;"\n      />\n    </a>\n  </div>\n';
}
return __p;
};
